import { createReducer, on } from '@ngrx/store';
import { 
    cargaEntregables, 
    cargaEntregablesCampos,
    resetEntregables
} from './actions';
import { iEntregables, mEntregables } from '../../entrada/entrada.interface';

export const initialState: iEntregables[] = [];

export const entregablesReducer = createReducer(
    initialState,
    on(cargaEntregables, (state, payload) => {
        return [...payload.oEntregables]
    }),
    on(cargaEntregablesCampos, (state,  payload) => {
        return { 
            ...state, 
            ...payload.oData
        };
    }),
    on(resetEntregables, (state,  payload) => {
        return initialState;
    })
);